import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
  Chip,
  IconButton
} from '@mui/material';
import {
  Campaign as AnnouncementIcon,
  ArrowForward as ArrowIcon
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';

const safeAge = (ts) => {
  try {
    const d = ts?.toDate ? ts.toDate() : new Date(ts);
    return formatDistanceToNow(d, { addSuffix: true });
  } catch { return ''; }
};

const RecentAnnouncements = ({ announcements, loading }) => {
  if (loading) {
    return (
      <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <CardHeader
          avatar={<AnnouncementIcon color="primary" />}
          title="Recent Announcements"
        />
        <CardContent sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Loading...
          </Typography>
        </CardContent>
      </Card>
    );
  }

  if (!announcements || announcements.length === 0) {
    return (
      <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <CardHeader
          avatar={<AnnouncementIcon color="primary" />}
          title="Recent Announcements"
          action={
            <IconButton component={Link} to="/announcements">
              <ArrowIcon />
            </IconButton>
          }
        />
        <CardContent sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            No announcements yet. Be the first to create one!
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader
        avatar={<AnnouncementIcon color="primary" />}
        title="Recent Announcements"
        action={
          <IconButton component={Link} to="/announcements" title="View all">
            <ArrowIcon />
          </IconButton>
        }
      />
      <CardContent sx={{ pt: 0 }}>
        <List dense>
          {announcements.map((announcement, index) => (
            <ListItem
              key={announcement.id}
              sx={{
                borderLeft: 3,
                borderColor: 'primary.main',
                borderRadius: 1,
                mb: 1,
                bgcolor: 'background.default',
                '&:hover': {
                  bgcolor: 'action.hover'
                }
              }}
            >
              <ListItemText
                primary={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                      {announcement.title}
                    </Typography>
                    {index === 0 && (
                      <Chip label="New" size="small" color="success" sx={{ height: 20 }} />
                    )}
                  </Box>
                }
                secondary={
                  <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                      {announcement.message?.length > 100
                        ? `${announcement.message.substring(0, 100)}...`
                        : announcement.message}
                    </Typography>
                    <Typography variant="caption" color="text.disabled">
                      {announcement.createdAt && safeAge(announcement.createdAt)}
                    </Typography>
                  </Box>
                }
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default RecentAnnouncements;
